import React from 'react'

/**
 * Oversized node constellation built from the Aldaron mark's geometry.
 * Used as hero artwork — slow rotation on the outer rings only, so the
 * nodes stay legible.
 */
const Constellation = ({ className = '' }) => (
  <svg viewBox="0 0 520 520" className={className} aria-hidden="true" fill="none">
    <defs>
      <radialGradient id="cnstGlow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#3B64F5" stopOpacity="0.30" />
        <stop offset="100%" stopColor="#3B64F5" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="cnstEdge" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#8FAEFF" stopOpacity="0.85" />
        <stop offset="100%" stopColor="#3B64F5" stopOpacity="0.25" />
      </linearGradient>
    </defs>

    <circle cx="260" cy="260" r="230" fill="url(#cnstGlow)" />

    {/* rotating orbital rings */}
    <g className="origin-center animate-spin-slow">
      <circle cx="260" cy="260" r="228" stroke="#F5F2EC" strokeOpacity="0.09" strokeDasharray="2 10" />
      <circle cx="260" cy="260" r="176" stroke="#F5F2EC" strokeOpacity="0.07" />
      <circle cx="260" cy="260" r="176" stroke="#8FAEFF" strokeOpacity="0.5" strokeDasharray="34 460" strokeLinecap="round" strokeWidth="2" />
    </g>

    {/* the mark, scaled up: three nodes forming an A plus a breakout arrow */}
    <g transform="translate(130 120) scale(2.1)">
      <g stroke="url(#cnstEdge)" strokeLinecap="round" strokeWidth="11">
        <path d="M45 38 30 80" />
        <path d="M57 36 78 72" />
        <path d="M34 78 66 55" />
      </g>
      <g fill="#F5F2EC">
        <circle cx="49" cy="27" r="13" />
        <circle cx="26" cy="87" r="13" />
        <circle cx="83" cy="80" r="11" />
      </g>
      <path d="M74 47 106 33 96 64 89 53 79 59z" fill="#3B64F5" />
    </g>

    {/* satellite nodes */}
    {[
      [78, 168],
      [452, 214],
      [140, 430],
      [400, 424],
    ].map(([cx, cy]) => (
      <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="3.5" fill="#8FAEFF" fillOpacity="0.55" />
    ))}
  </svg>
)

export default Constellation
